// @flow
import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Field } from 'redux-form';
import { FullButton, HoshiInput } from '../../../../components/common';
import I18n from '../../../../lib/i18n';

class ResetPasswordForm extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View>
        <Field
          autoFocus
          name="email"
          component={HoshiInput}
          type="email"
          placeholder={I18n.t('email')}
          returnKeyType="go"
          style={styles.input}
          onSubmitEditing={this.props.handleSubmit}
          testID="resetPassword-email-input"
        />
        <FullButton
          text={I18n.t('sendEmail')}
          onPress={this.props.handleSubmit}
          isLoading={this.props.isResettingPassword}
        />
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    input: {
      marginVertical: 8,
    },
  });

type Props = StateProps & DispatchProps;

export type StateProps = {
  isResettingPassword: boolean,
};

export type DispatchProps = {
  handleSubmit: Function,
};

export default ResetPasswordForm;
